import React, {PureComponent} from "react"

import FormattedMessage from "@irati/utils/lang"
import {Label} from "@irati/ui/src/Typography"

import {StyledRow} from "../styled/MyPerksItem"
import ColWithPadding from "../styled/ColWithPadding"

export default class TimeLimitedDeal extends PureComponent {
  render() {
    return (
      <StyledRow>
        <ColWithPadding xs={3} sm={2} />
        <ColWithPadding xs={9} sm={10}>
          <Label large display="block">
            <FormattedMessage id="perks.myPerks.myPerksItem.expiredDeal.header" />
          </Label>
          <Label>
            <FormattedMessage id="perks.myPerks.myPerksItem.expiredDeal.body" />
          </Label>
        </ColWithPadding>
      </StyledRow>
    )
  }
}
